<template>
  <div class="modal fade show" tabindex="-1" role="dialog" style="display: block;">
    <div class="modal-dialog modal-dialog-centered" role="document">
      <div class="modal-content tl-modal">
        <div class="modal-header tl-modal-header">
          <h5 class="modal-title">{{ isEditing ? 'Edit Service' : 'Add New Service' }}</h5>
          <button type="button" class="close" aria-label="Close" @click="handleClose">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body tl-modal-body">
          <form @submit.prevent="submitForm">
            <div class="form-row">
              <div class="form-group col-md-6 tl-form-group">
                <label class="tl-label">Item <span class="text-danger">*</span></label>
                <input type="text" class="tl-input" v-model="form.item" required placeholder="Enter item name">
              </div>
              <div class="form-group col-md-6 tl-form-group">
                <label class="tl-label">Type <span class="text-danger">*</span></label>
                <select class="tl-select" v-model="form.type" @change="handleTypeChange" required>
                  <option v-for="option in typeOptions" :key="option" :value="option">{{ option }}</option>
                </select>
              </div>
            </div>

            <!-- Conditionally Render Fields Based on Type -->
            <div v-if="form.type === 'bulk' || form.type === 'hourly'" class="form-row mt-3">
              <div class="form-group col-md-12 tl-form-group">
                <label class="tl-label">Price (Gross) <span class="text-danger">*</span></label>
                <input type="decimal" step="1" class="tl-input" v-model="form.price" required>
              </div>
            </div>

            <div v-if="form.type === 'per person'" class="form-row mt-3">
              <div class="form-group col-md-6 tl-form-group">
                <label class="tl-label">Adult Price (Gross) <span class="text-danger">*</span></label>
                <input type="decimal" step="1" class="tl-input" v-model="form.adultPrice_gross" required>
              </div>
              <div class="form-group col-md-6 tl-form-group">
                <label class="tl-label">Child Price (Gross) <span class="text-danger">*</span></label>
                <input type="decimal" step="1" class="tl-input" v-model="form.childPrice_gross" required>
              </div>
            </div>

            <div class="form-row mt-3">
              <div class="form-group col-md-4 tl-form-group">
                <label class="tl-label">Tax <span class="text-danger">*</span></label>
                <select class="tl-select" v-model="form.tax" required>
                  <option v-for="option in taxOptions" :key="option" :value="option">{{ option }}</option>
                </select>
              </div>
              <div class="form-group col-md-4 tl-form-group">
                <label class="tl-label">Rate <span class="text-danger">*</span></label>
                <input type="decimal" step="1" class="tl-input" v-model="form.rate" required>
              </div>
              <div class="form-group col-md-4 tl-form-group">
                <label class="tl-label">Category <span class="text-danger">*</span></label>
                <select class="tl-select" v-model="form.catagory" required>
                  <option v-for="option in categoryOptions" :key="option" :value="option">{{ option }}</option>
                </select>
              </div>
            </div>

            <div class="form-row mt-3">
              <div class="form-group col-md-6 tl-form-group">
                <label class="tl-label">Remarks</label>
                <textarea class="tl-input tl-textarea" v-model="form.remarks" rows="2"></textarea>
              </div>
              <div class="form-group col-md-6 tl-form-group">
                <label class="tl-label">Cancellation</label>
                <input type="text" class="tl-input" v-model="form.cancellation">
              </div>
            </div>

            <div class="form-row mt-3">
              <div class="form-group col-md-6 tl-form-group">
                <label class="tl-label">Year <span class="text-danger">*</span></label>
                <select class="tl-select" v-model="form.year" required>
                  <option v-for="year in yearOptions" :key="year" :value="year">{{ year }}</option>
                </select>
              </div>
              <div class="form-group col-md-6 tl-form-group">
                <label class="tl-label">Supplier <span class="text-danger">*</span></label>
                <input type="text" class="tl-input" v-model="form.supplier" required>
              </div>
            </div>

            <div class="form-row mt-3">
              <div class="form-group col-md-12 tl-form-group">
                <label class="tl-label">Select City</label>
                <div class="tl-select-group">
                  <select class="tl-select" v-model="selectedCity">
                    <option v-for="city in cityOptions" :key="city.value" :value="city.value">
                      {{ city.text }}
                    </option>
                  </select>
                  <button type="button" class="tl-btn-plus" @click="addCity">+</button>
                </div>

                <div class="mt-3">
                  <label class="tl-label-sub">Selected Cities</label>
                  <div class="tl-selected-list">
                    <div class="tl-selected-item" v-for="(city, index) in form.cities" :key="index">
                      <span>{{ getCityName(city.id) }}</span>
                      <button type="button" class="tl-remove-btn" @click="removeCity(index)">&times;</button>
                    </div>
                  </div>
                  <div v-if="cityError" class="tl-error-text">Please select at least one city.</div>
                </div>
              </div>
            </div>

            <div class="tl-form-actions mt-4">
              <button type="submit" class="tl-btn-submit">{{ isEditing ? 'Update' : 'Submit' }}</button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    service: Object,
    cities: {
      type: Array,
    }
  },
  data() {
    const startYear = 2024;
    return {
      form: {
        item: '',
        adultPrice_net: null,
        childPrice_net: null,
        price: '',
        type: '',
        tax: '',
        rate: null,
        adultPrice_gross: null,
        childPrice_gross: null,
        catagory: '',
        remarks: '',
        cancellation: '',
        year: null,
        cities: [],
        supplier: ''
      },
      yearOptions: Array.from({ length: 15 }, (v, i) => startYear + i), // Starting from 2024, going forward 20 years

      selectedCity: null,
      typeOptions: ['per person', 'bulk', 'hourly'],
      taxOptions: ['Toms', 'VAT', 'Rcv'],
      categoryOptions: ['Accommodation', 'F&B', 'Staff', 'Transportation', 'Insides', 'Additional Services'],
      cityOptions: [],
      cityError: false
    };
  },
  computed: {
    isEditing() {
      return this.service !== null;
    }
  },
  mounted() {
    this.fetchCities();
    if (this.isEditing && this.service) {
      this.form = {
        ...this.service.attributes,
        cities: Array.isArray(this.service.attributes.cities?.data)
          ? this.service.attributes.cities.data.map(city => ({ id: city.id }))
          : []
      };
    }
  },

  methods: {
    async fetchCities() {
      try {
        const response = await this.$xhr.get('/api/citylondons?pagination[pageSize]=1000&sort[0]=city:asc');
        this.cityOptions = response.data.data.map(city => ({
          value: city.id,
          text: city.attributes.city
        }));
      } catch (error) {
        console.error("Error fetching cities:", error);
      }
    },

    handleTypeChange() {
      if (this.form.type === 'bulk' || this.form.type === 'hourly') {
        this.form.adultPrice_net = null;
        this.form.childPrice_net = null;
        this.form.adultPrice_gross = null;
        this.form.childPrice_gross = null;
      } else if (this.form.type === 'per person') {
        this.form.price = null;
      }
    },
    handleClose() {
      this.$emit('close');
    },
    addCity() {
      if (this.selectedCity) {
        this.form.cities.push({ id: this.selectedCity });
        this.selectedCity = null;  // Reset the dropdown
        this.cityError = false;  // Reset error state
      } else {
        this.cityError = true;
      }
    },
    removeCity(index) {
      this.form.cities.splice(index, 1);
    },
    getCityName(cityId) {
      const city = this.cities.find(city => city.id === cityId);
      return city ? city.attributes.city : 'Unknown';
    },
    normalizePrice(value) {
      if (typeof value === 'string') {
        return value.replace(',', '.');
      }
      return value;
    },
    async submitForm() {
      this.cityError = false;

      if (this.form.cities.length === 0 || this.form.cities.some(city => !city.id)) {
        this.cityError = true;
        this.$bvToast.toast('Please select at least one city.', {
          title: 'Error',
          variant: 'danger',
          solid: true
        });
        return;
      }

      if (!this.isEditing) {
        const itemExists = await this.checkItemExists(this.form.item, this.form.year);
        if (itemExists) {
          this.$bvToast.toast('An item with the same name already exists for the selected year.', {
            title: 'Error',
            variant: 'danger',
            solid: true
          });
          return;
        }
      }

      if (this.form.type === 'per person') {
        this.form.adultPrice_gross = this.normalizePrice(this.form.adultPrice_gross);
        this.form.childPrice_gross = this.normalizePrice(this.form.childPrice_gross);
        if (this.form.tax === 'Toms') {
          this.form.adultPrice_net = Number(this.form.adultPrice_gross).toFixed(2);
          this.form.childPrice_net = Number(this.form.childPrice_gross).toFixed(2);
        } else {
          const rateMultiplier = 1 + (Number(this.form.rate) / 100);
          this.form.adultPrice_net = (Number(this.form.adultPrice_gross) / rateMultiplier).toFixed(2);
          this.form.childPrice_net = (Number(this.form.childPrice_gross) / rateMultiplier).toFixed(2);
        }
      } else {
        this.form.price = this.normalizePrice(this.form.price);
      }

      const formData = {
        ...this.form,
        cities: this.form.cities.map(city => city.id)
      };

      if (this.isEditing) {
        await this.$xhr.put(`/api/servicelondons/${this.service.id}`, { data: formData });
      } else {
        await this.$xhr.post('/api/servicelondons', { data: formData });
      }

      this.$emit('service-added');
      this.handleClose();
    },

    async checkItemExists(item, year) {
      try {
        const response = await this.$xhr.get(`/api/servicelondons?filters[item][$eq]=${item}&filters[year][$eq]=${year}`);
        return response.data.data.length > 0;
      } catch (error) {
        console.error("Error checking item existence:", error);
        return false;
      }
    }

  }
};
</script>



<style scoped>
.modal-dialog-centered {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  max-width: 800px;
  /* Reduced for better proportion */
}

.tl-modal {
  border: none;
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);
}

.tl-modal-header {
  background: #fff;
  border-bottom: 1px solid #f1f5f9;
  padding: 16px 24px;
}

.tl-modal-header .modal-title {
  font-size: 1.15rem;
  font-weight: 800;
  color: #1e293b;
}

.tl-modal-body {
  padding: 24px;
  background: #fff;
  max-height: 85vh;
  overflow-y: auto;
}

.tl-form-group {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.tl-label {
  font-size: 0.8rem;
  text-transform: uppercase;
  font-weight: 700;
  color: #64748b;
  letter-spacing: 0.05em;
  margin-bottom: 4px;
}

.tl-input,
.tl-select {
  width: 100%;
  height: 34px;
  padding: 0 10px;
  border: 1px solid #dee2e6;
  border-radius: 6px;
  background: #f9fafb;
  font-size: 0.82rem;
  color: #374151;
  transition: all 0.2s;
  outline: none;
}

.tl-textarea {
  height: auto;
  padding: 12px 16px;
}

.tl-input:focus,
.tl-select:focus {
  border-color: #E2923D;
  background: #fff;
  box-shadow: 0 0 0 3px rgba(226, 146, 61, 0.15);
}

.tl-select-group {
  display: flex;
  gap: 12px;
  width: 100%;
}

.tl-btn-plus {
  width: 42px;
  height: 42px;
  background: #64748b;
  color: #fff;
  border: none;
  border-radius: 8px;
  font-size: 1.2rem;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: background 0.2s;
}

.tl-btn-plus:hover {
  background: #475569;
}

.tl-label-sub {
  display: block;
  font-size: 0.72rem;
  font-weight: 700;
  text-transform: uppercase;
  color: #94a3b8;
  margin-bottom: 8px;
  letter-spacing: 0.05em;
}

.tl-selected-list {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

.tl-selected-item {
  background: #f1f5f9;
  padding: 4px 10px;
  border-radius: 6px;
  font-size: 0.85rem;
  color: #475569;
  display: flex;
  align-items: center;
  gap: 6px;
  border: 1px solid #e2e8f0;
}

.tl-remove-btn {
  background: none;
  border: none;
  color: #94a3b8;
  font-size: 1.1rem;
  padding: 0;
  line-height: 1;
  cursor: pointer;
}

.tl-remove-btn:hover {
  color: #ef4444;
}

.tl-form-actions {
  display: flex;
  justify-content: flex-end;
}

.tl-btn-submit {
  background: #E2923D;
  color: #fff;
  border: none;
  border-radius: 6px;
  padding: 0 24px;
  height: 34px;
  font-weight: 700;
  font-size: 0.8rem;
  cursor: pointer;
  transition: opacity 0.2s;
}

.tl-btn-submit:hover {
  opacity: 0.9;
}

.tl-error-text {
  color: #ef4444;
  font-size: 0.85rem;
  margin-top: 8px;
  text-align: center;
}
</style>
